import { ProductAttributeFilter } from "@interfaces/components/product-filters.interface";
import { decode } from "html-entities";

interface Props {
  attributeFilters: ProductAttributeFilter[];
  selectedAttributeFilters: number[];
  onFilterChange: (filterValue: number, isChecked: boolean) => void;
}

const SubcategoriesFilter = ({
  attributeFilters,
  selectedAttributeFilters,
  onFilterChange,
}: Props) => {
  return (
    <div className="filter-category-list rounded-2">
      <div className="filter-title">
        <h3>หมวดหมู่</h3>
      </div>
      <ul>
        {attributeFilters.map(({ display, value, count }) => (
          <li key={value}>
            <div className="form-check category-list-box">
              <input
                className="form-check-input"
                type="checkbox"
                checked={selectedAttributeFilters.some((attr) => attr === value)}
                onChange={(e) => onFilterChange(value, e.target.checked)}
              />
              <label className="form-check-label">
                {decode(display)} ({count})
              </label>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubcategoriesFilter;
